import React, { useCallback } from 'react'
import { useLocalStorage } from './useLocalStorage'
import { useState } from "react"

export const useAuth = () => {
    const [user, setUser] = useLocalStorage("token", null)

    const getAccessTokenSilently = useCallback(() => {
        try {
            return user?.access_token
        } catch (error) {
            return null
        }
    }, [user?.access_token])

    const setToken = useCallback((token) => {
        setUser(token)
    }, [setUser])

    const logout = useCallback((url) => {
        setUser(null)
        window.location.href = url
    }, [setUser])

    return { user, getAccessTokenSilently, setToken, logout }
}